import {Link} from 'react-router-dom'

import pic from './logo.png'
import './App.css'
function Footer(){

    return(
        <div className=" mt-5">
           <div className="ocean">
  <div className="wave"></div>
  <div className="wave"></div>
  <div className="wave"></div>
</div>
        <div className="row bg-dark text-light">
                <div className="col-12 col-sm-4 ">
                        <nav className = "navbar pl-4 navbar-expand-sm bg-dark navbar-dark ">
                        <navbrand> 
                        <Link to="/"><img className="logo" src={pic} alt="this is a logo" /></Link> 
                        </navbrand>
                        <ul className = "navbar-nav ml-auto ">
                        <li className = "nav-item active">
                            <Link className = "nav-link text-warning" to = "/">Home 
                                <span className = "sr-only">(current)</span>
                            </Link>
                        </li>
                        <li className = "nav-item">
                            <Link className = "nav-link text-warning" to = "/about">About Us</Link>
                        </li>
                        <li className = "nav-item">
                            <Link className = "nav-link text-warning" to = "/contact">Contact</Link>
                        </li>
                        </ul>
                        
                        </nav>
                </div>

            <div className="col-12 col-sm-4 ml-auto">
           
        </div>
            
           
           

        </div>
        </div>
    )
}

export default Footer;




